import type React from 'react';
import { useUserRole } from '../hooks/useUserRole';

/**
 * Component to protect admin-only routes
 * Shows loading while checking role, access denied if not admin
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoaded } = useUserRole();

  // Show loading while checking role
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // Show access denied if not admin
  if (!isAdmin) {
    return <AccessDenied />;
  }

  // Render protected content for admins
  return <>{children}</>;
}

/**
 * Access denied page for non-admin users
 */
function AccessDenied() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center max-w-md p-8">
        <h1 className="text-3xl font-bold mb-4">Access Denied</h1>
        <p className="text-muted-foreground mb-6">
          You need administrator privileges to access this page.
        </p>
        <p className="text-sm text-muted-foreground">
          If you believe you should have access, please contact your system administrator.
        </p>
      </div>
    </div>
  );
}
